var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "star1",
    d: "M64.1894 59.6479L56.2362 55.3071C53.1596 53.6295 50.6301 51.1071 48.9478 48.0392L44.5947 40.1084L40.2416 48.0392C38.5593 51.1071 36.0298 53.6295 32.9532 55.3071L25 59.6479L32.9532 63.9828C36.0298 65.6604 38.5593 68.1828 40.2416 71.2508L44.5947 79.1874L48.9478 71.2508C50.6301 68.1828 53.1596 65.6604 56.2362 63.9828L64.1894 59.6479Z",
    fill: "#7738E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "star2",
    d: "M78.5074 36.0088L73.2131 33.111C71.16 31.9907 69.4717 30.3072 68.3482 28.2598L65.4423 22.9805L62.5363 28.2598C61.4128 30.3072 59.7246 31.9907 57.6715 33.111L52.3772 36.0088L57.6715 38.9065C59.7159 40.0304 61.3956 41.7136 62.5128 43.7577L65.4187 49.0371L68.3247 43.7577C69.4482 41.7103 71.1364 40.0269 73.1896 38.9065L78.5074 36.0088Z",
    fill: "#7738E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "star3",
    d: "M44.3358 29.538L40.4533 27.4204C38.9612 26.5977 37.7364 25.3663 36.9238 23.8715L34.8002 20L32.6472 23.8657C31.8267 25.3644 30.5913 26.5964 29.0883 27.4146L25.2 29.5322L29.0883 31.6557C30.5872 32.466 31.8222 33.6873 32.6472 35.1752L34.7708 39.0468L36.8944 35.1752C37.7115 33.6913 38.9358 32.4704 40.4239 31.6557L44.3358 29.538Z",
    fill: "#7738E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logo_sm.537480cd.svg";
export { ForwardRef as ReactComponent };